export function checkValidMimirURl(url: string, mimirHost: string) {
  try {
    // URL constructor throws an error on an invalid URL
    const navigationURLObject = new URL(url);

    // Check if entered url host matches current host
    const enteredHost = navigationURLObject.host;
    if(enteredHost !== mimirHost) {
      return false;
    }
    return true;
  } catch(e) {
    return false;
  }
}

export function extractIdFromItemDetailsLink(url: string) {
  const pattern = /item-details\/([0-9a-fA-F-]{36})/;
  const match = pattern.exec(url);
  return match ? match[1] : null;
}
